<template>
  <div class="auth-modal">
    <!-- Modal Starts Here -->
    <div
      class="modal fade"
      id="addCircleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addCircleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0 border-0">
            <button id="addCircleDismissBtn" @click="resetForm()" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                <ion-icon name="ios-close" size="large"></ion-icon>
              </span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-12 col-md-12 mb-3">
                    <h3 class="title mb-4">{{ formText.heading }}</h3>
                    <div class="form-group">
                        <label for="title">Title</label>
                        <input name="title" type="text" v-model="title" class="form-control" placeholder="Circle title. (Ex. Infodemics for Polio)" />
                    </div>

                    <div class="form-group" v-if="type && (type.toLowerCase() !== 'ivr')">
                        <label>Type</label>
                        <select type="text" v-model="flags[0].value" class="form-control">
                            <option :value="null">-- Select a type --</option>
                            <option value="public">Public</option>
                            <option value="private">Private</option>
                        </select>
                    </div>

                    <div class="d-flex align-items-center justify-content-between">
                        <label>Joining Requirements</label>
                        <span @click="addRequirement()"><ion-icon name="ios-add-circle-outline" style="font-size:24px; color: var(--primary-color); cursor: pointer;"></ion-icon></span>
                    </div>
                    <small class="form-text text-muted mb-3">A circle must have at least one joining requirement</small>
                    <div class="d-flex align-items-center justify-content-between mb-3" v-for="(req, index) of requirements" :key="req.id">
                        <input v-model="req.value" class="form-control mr-3"  type="text" placeholder="Requirement title. (Ex. Name)"/>
                        <a v-if="index !== 0" href="#" style="color: var(--danger)" @click.prevent="removeRequirement(req.id)">Remove</a>
                        <a v-if="index === 0" href="#" @click.prevent style="visibility: hidden">Remove</a>
                    </div>
                  <button @click="submit($event)" id="addCircleSubmitBtn" class="btn btn-block btn-primary text-white" :disabled="!formIsValid">{{ formText.btnText }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import CircleService from "@/services/circle";
    import { mapActions } from "vuex";
    import InMemoryDb from "@/services/inmemorydb";

    const circleService = new CircleService();
    const InMemoryDatabase = new InMemoryDb();

    export default {
        name: "AddCircle",
        props: ["type", "parent", "user"],
        data() {
            return {
                title: null,
                requirements: [
                    { id: 0, value: null }
                ],
                flags: [
                    { id: 0, type: "visibility", value: null },
                    { id: 1, type: "type", value: null }
                ]
            }
        },
        computed: {
            formText: function() {
                let heading = "New Circle";
                let btnText = "Create Circle";
                let loadingText = "Creating Circle";
                if (this.$props.type) {
                    if (this.$props.type.toLowerCase() !== "main") {
                        heading = `New ${this.$props.type} Circle`;
                        btnText = `Create ${this.$props.type} Circle`;
                        loadingText = `Creating ${this.$props.type} Circle`;
                    }

                    if (this.$props.parent) {
                        heading = `New Child Circle for "${this.$props.parent.title}"`;
                    }
                }
                return { heading, btnText, loadingText };
            },
            formIsValid: function() {
                return this.title && this.requirements && this.requirements.length > 0 && !this.requirements.find(s => !s.value) &&
                    this.flags && this.flags.length > 0 && !this.flags.find(s => !s.value);
            }
        },
        methods: {
            ...mapActions(["addCircle"]),
            resetForm() {
                this.title = null;
                this.requirements = [ { id: 0, value: null }];
                this.flags = [
                    { id: 0, type: "visibility", value: null },
                    { id: 1, type: "type", value: null }
                ]
            },
            addRequirement() {
                this.requirements = [...this.requirements, { id: this.requirements.length, value: null}];
            },
            removeRequirement(id) {
                this.requirements = this.requirements.filter(s => s.id !== id);
            },
            submit(e) {
                const submitBtn = e.srcElement;
                const closeBtn = document.getElementById("addCircleDismissBtn");

                if (this.$props.type.toLowerCase() !== "child") {
                    const form = {
                        title: this.title,
                        requirements: this.requirements,
                        profile_id: this.$props.user._id,
                        upload_id: "-",
                        status: "active",
                        flags: this.flags
                    };
                    
                    submitBtn.disabled = true;
                    submitBtn.innerText = this.formText.loadingText;
                    submitBtn.classList.add("btn--loading");

                    circleService.addCircle(form).then((circle) => {
                        closeBtn.click();
                        InMemoryDatabase.addCircle(circle);
                        this.addCircle(circle);
                        submitBtn.disabled = false;
                        submitBtn.innerText = this.formText.btnText;
                        submitBtn.classList.remove("btn--loading");
                        this.$notification.new(`"${circle.title}" circle created`);
                    }).catch(err => {
                        submitBtn.disabled = false;
                        submitBtn.innerText = this.formText.btnText;
                        submitBtn.classList.remove("btn--loading");
                        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
                        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
                    })
                } else {
                    const boards = [];
                    const parentBoard = this.$props.parent.board || this.$props.parent.boards || [];

                    const parentOwner = parentBoard.find(s => s.type === "role" && s.status === "owner");
                    boards.push({ profile_id: parentOwner.profile_id, type: "role", status: "owner" });
                    if (parentOwner.profile_id !== this.$props.user._id) {
                        boards.push({ profile_id: parentOwner.profile_id, type: "role", status: "administrator" });
                    }

                    const form = {
                        title: this.title,
                        requirements: this.requirements,
                        upload_id: "-",
                        status: "active",
                        flags: this.flags,
                        boards,
                        parent_id: this.$props.parent._id
                    };
                    
                    submitBtn.disabled = true;
                    submitBtn.innerText = this.formText.loadingText;
                    submitBtn.classList.add("btn--loading");

                    circleService.addChildCircle(form).then((res) => {
                        this.$root.$emit("SaveNewChildCircle", res);
                        submitBtn.disabled = false;
                        submitBtn.innerText = this.formText.btnText;
                        submitBtn.classList.remove("btn--loading");
                        this.$notification.new(`Child circle "${form.title}" created`);
                        closeBtn.click();
                    }).catch(err => {
                        submitBtn.disabled = false;
                        submitBtn.innerText = this.formText.btnText;
                        submitBtn.classList.remove("btn--loading");
                        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
                        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
                    })
                }
            }
        },
        mounted() {
            const modal = document.getElementById("addCircleModal");

            const disposeModal = function() {
                if (modal.style.display === 'none') {
                    this.resetForm.call(this);
                }
            };

            modal.addEventListener("blur", disposeModal.bind(this));
        },
        watch: {
            type: {
                handler: function(val) {
                    if (val) {
                        switch (val.toLowerCase()) {
                            case "main":
                                this.flags[1].value = "main";
                                break;

                            case "ivr":
                                this.flags[1].value = "ivr";
                                this.flags[0].value = "private";
                                break;

                            case "child":
                                this.flags[1].value = "child";
                                break;
                        
                            default:
                                this.flags[1].value = "main";
                                break;
                        }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>